import React, {Component} from 'react'

import './SnackBarContainer.css'
import Button from 'react-toolbox/lib/button/Button'
/** REDUX**/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as nodeChartsActions from '../../../../../actions/nodeCharts'

class SnackBarContainer extends Component {

    handleSnackbar(key) {
        this.props.nodeChartsActions.removeErrors(key)
    }

    displaySnackBar(err, key) {
        setTimeout(() => {
            this.props.nodeChartsActions.removeErrors(key)
        }, 8000);

        return (<div className='col-xs-11 snackBarElement fadeIn bottomAnimation' key={key}>
            <p>{err}</p>
            <Button label={'DISMISS'} onClick={this.handleSnackbar.bind(this, key)}/>
        </div>)
    }

    render() {
        return (
            <div className='row snackBarContainer'>
                {this.props.errors.map((err, key) => {
                    return this.displaySnackBar(err, key);
                })}
            </div>
        )
    }
}

const nodeChartStateToProps = (state) => {
    return {
        errors: state.nodeCharts.errors

    }
};
const nodeChartDispatchToProps = (dispatch) => {
    return {
        nodeChartsActions: bindActionCreators(nodeChartsActions, dispatch),
    }
};

export default connect(nodeChartStateToProps, nodeChartDispatchToProps)(SnackBarContainer)




// WEBPACK FOOTER //
// ./src/components/DashBoard/ManageStations/StationCharts/SnackBarContainer/SnackBarContainer.js